import type { FilterFieldOption } from '~/components/ui';
import { SavedViewsFilterControls } from '~/components/ui/SavedViewsFilterControls';
import type { TradePerspective } from '~/graphql/graphql';
import { activeRowCount } from '~/pages/orders/lib/orderFilters';
import type { OrdersSavedViews } from '~/pages/orders/lib/useOrdersSavedViews';
import { OrdersFilter } from '~/pages/orders/sections/OrdersFilter';

type OrdersToolbarProps = {
  readonly fieldOptions: FilterFieldOption[];
  readonly perspective: TradePerspective;
  readonly views: OrdersSavedViews;
};

export function OrdersToolbar({
  fieldOptions,
  perspective,
  views,
}: OrdersToolbarProps) {
  return (
    <div className="flex items-center gap-4 justify-end">
      <SavedViewsFilterControls
        namespace="order"
        keyPrefix="order.filter"
        views={views}
        activeCount={activeRowCount(views.rows, perspective)}
        buttonTestId="orders-filter-button"
        countTestId="orders-filter-count"
        renderPanel={({ maxHeight, bottomContent }) => (
          <OrdersFilter
            maxHeight={maxHeight}
            bottomContent={bottomContent}
            rows={views.rows}
            fieldOptions={fieldOptions}
            onRowsChange={views.setRows}
          />
        )}
      />
    </div>
  );
}
